import { createReducer } from '@reduxjs/toolkit'

import { defaultPage as defaultPageState } from 'reducers/ui/defaults'

export default createReducer(defaultPageState, () => {})
